var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgBarcode = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.73333V18.4444C1 18.8495 1.32832 19.1778 1.73333 19.1778C2.13834 19.1778 2.46667 18.8495 2.46667 18.4444V5.73333C2.46667 5.32832 2.13834 5 1.73333 5C1.32832 5 1 5.32832 1 5.73333ZM3.6074 5.73333C3.6074 5.32832 3.93572 5 4.34073 5H6.29629C6.7013 5 7.02962 5.32832 7.02962 5.73333V15.5111C7.02962 15.9161 6.7013 16.2444 6.29629 16.2444H4.34073C3.93572 16.2444 3.6074 15.9161 3.6074 15.5111V5.73333ZM14.6074 5C14.2024 5 13.8741 5.32832 13.8741 5.73333V15.5111C13.8741 15.9161 14.2024 16.2444 14.6074 16.2444H16.563C16.968 16.2444 17.2963 15.9161 17.2963 15.5111V5.73333C17.2963 5.32832 16.968 5 16.563 5H14.6074ZM8.17038 5.73333V15.5111C8.17038 15.9161 8.4987 16.2444 8.90371 16.2444C9.30872 16.2444 9.63705 15.9161 9.63705 15.5111V5.73333C9.63705 5.32832 9.30872 5 8.90371 5C8.4987 5 8.17038 5.32832 8.17038 5.73333ZM11.2667 15.5111V5.73333C11.2667 5.32832 11.595 5 12 5C12.405 5 12.7333 5.32832 12.7333 5.73333V15.5111C12.7333 15.9161 12.405 16.2444 12 16.2444C11.595 16.2444 11.2667 15.9161 11.2667 15.5111ZM18.437 5.73333V15.5111C18.437 15.9161 18.7654 16.2444 19.1704 16.2444C19.5754 16.2444 19.9037 15.9161 19.9037 15.5111V5.73333C19.9037 5.32832 19.5754 5 19.1704 5C18.7654 5 18.437 5.32832 18.437 5.73333ZM21.5333 18.4444V5.73333C21.5333 5.32832 21.8617 5 22.2667 5C22.6717 5 23 5.32832 23 5.73333V18.4444C23 18.8495 22.6717 19.1778 22.2667 19.1778C21.8617 19.1778 21.5333 18.8495 21.5333 18.4444Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgBarcode;